// @flow
import * as React from 'react';

import {
  selectOneProductErrors,
  type AcmeProduct,
  type DecoratedProduct,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { ErrorBoundary } from 'src/helpers/ErrorBoundary';
import { useAppSelector } from 'src/hooks';

import { DomainRow } from './Acme/DomainRow';
import { DomainsByProcess } from './Acme/DomainsByProcess';
import ProductItem from './components/ProductItem';

type Props = {
  product: AcmeProduct & DecoratedProduct,
  domains: Array<string>,
  footer: React.Node,
  children?: React.Node,
};

export function AcmeProductItem({
  product,
  domains,
  footer,
  children,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const productErrors = useAppSelector(state =>
    selectOneProductErrors(state, { productId: product.id }),
  );

  const label = product.payload.name || __('ACME Subscription');

  return (
    <ProductItem
      label={label}
      productId={product.id}
      errors={productErrors}
      footer={footer}
    >
      {children}

      {domains ? (
        <ErrorBoundary fallback={<DomainRow matchedDomains={domains} />}>
          <DomainsByProcess prices={product.prices} domains={domains} />
        </ErrorBoundary>
      ) : null}
    </ProductItem>
  );
}
